export default {
  id: 'rsrc.updatedAt',
  name: 'rsrc.updatedAt',
  displayName: 'Rsrc Updated',
  valueType: 'timestamp',
  objectType: 'rsrc',
  placement: {
    group: []
  },
  get: obj => {
    return new Date(obj?.updatedAt);
  },
  sourceOptions: {
    sortable: true,
    sortField: 'updatedAt'
  }
};